import catalog from "../data/blogs/catalog.json";
import articles from "../data/blogs/articles.json";

export const BLOG_CATALOG = catalog;
export const BLOG_ARTICLES = articles;
export const BLOGS_PER_PAGE = 15;

/**
 * Match gallery asset to blog number (Blog 1 … Blog 69 filenames).
 */
export function getBlogImageForNumber(number, gallery) {
  if (!gallery?.length) return null;
  const prefix = `blog ${number}`.toLowerCase();
  const match = gallery.find((item) =>
    (item.pairingKey || item.alt || "").toLowerCase().startsWith(prefix),
  );
  if (match) return match;
  const index = (number - 1) % gallery.length;
  return gallery[index] ?? null;
}

export function getBlogBySlug(slug) {
  const meta = BLOG_CATALOG.find((p) => p.id === slug);
  const article = BLOG_ARTICLES[slug];
  if (!meta || !article) return null;
  return { ...meta, ...article };
}
